<template>
	<div class="invoice-detail">

		<van-form @submit="save">
			<div class="page-title">{{id ? '编辑' : '新增'}}抬头</div>

			<van-cell title="抬头类型" class="title">
				<template #label>
					<van-tabs type="card" v-model="ruleForm.type" class="field">
						<van-tab title="个人抬头" name="personal"></van-tab>
						<van-tab title="单位抬头" name="company"></van-tab>
					</van-tabs>
				</template>
			</van-cell>

			<van-cell title="抬头名称" class="title required">
				<template #label>
					<van-field v-model="ruleForm.name"
					:rules="[{ required: true, message: '请填写抬头名称' }]"
					placeholder="抬头名称"
					class="field" />
				</template>
			</van-cell>

			<div v-if="ruleForm.type === 'company'">

				<van-cell title="纳税人识别号" class="title required">
					<template #label>
						<van-field v-model="ruleForm.taxpayer_no"
						:rules="[{ required: true, message: '请填写纳税人识别号' }]"
						placeholder="纳税人识别号"
						class="field" />
					</template>
				</van-cell>

				<van-cell title="企业地址" class="title">
					<template #label>
						<van-field v-model="ruleForm.business_address"
						placeholder="企业地址"
						class="field" />
					</template>
				</van-cell>

				<van-cell title="电话" class="title">
					<template #label>
						<van-field v-model="ruleForm.business_telephone"
						placeholder="电话"
						class="field" />
					</template>
				</van-cell>

				<van-cell title="开户行" class="title">
					<template #label>
						<van-field v-model="ruleForm.bank_of_deposit"
						placeholder="开户行"
						class="field" />
					</template>
				</van-cell>

				<van-cell title="银行账号" class="title">
					<template #label>
						<van-field v-model="ruleForm.bank_account"
						placeholder="银行账号"
						class="field" />
					</template>
				</van-cell>
			</div>

			<van-cell title="手机号" class="title">
				<template #label>
					<van-field v-model="ruleForm.phone"
					placeholder="手机号"
					class="field" />
				</template>
			</van-cell>

			<van-cell title="备注" class="title">
				<template #label>
					<van-field v-model="ruleForm.remarks"
					placeholder="请输入备注"
					class="field" />
				</template>
			</van-cell>

			<div style="display: flex;justify-content: center;padding:0.6rem 0;">
				<van-button type="danger" round class="SubmitBtn" native-type="submit">提交</van-button>
			</div>
		</van-form>
	</div>
</template>

<script>
    import api from "../../assets/js/api";

    export default {
        name: "InvoiceDetail",
        data(){
            return {
                isLoading: false,
                ruleForm: {
					id: '',
					type: 'company',
					name: '',
					phone: '',
					taxpayer_no: '',
					business_address: '',
					business_telephone: '',
					bank_of_deposit: '',
					bank_account: '',
					remarks: '',
                },
                id: '',
            };
        },
        created() {
            let self = this;
            if (this.$route.query.id) {
                this.isLoading = true;
                this.id = this.$route.query.id;
                let loading = this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                api.request('/user_invoice_info/detail', {
                    'id' : this.id,
                }).then(res => {
                    self.ruleForm = res.data;
                }).finally(() => {
                    self.isLoading = false;
                    self.$toast.clear(loading);
                })
            }
        },
        methods : {
            save(){
                let self = this;
                if (this.isLoading) return;
                this.isLoading = true;
                let loading = this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
				api.request('/user_invoice_info/save', self.ruleForm).then(res => {
					self.$toast(res.msg);
					self.$router.back();
					self.$toast.clear(loading);
				}).catch(res => {
					self.$toast.clear(loading);
					self.$toast.fail(res.msg);
				}).finally(() => {
					self.isLoading = false;
				});
            },
        },
    }
</script>

<style lang="scss" scoped>
	.invoice-detail {
		margin: 10px;
		background: #fff;
		.page-title {
			padding: 0.4rem;
			font-size: 0.5rem;
			font-weight: bolder;
		}

		.required {
			&::before {
				position: absolute;
				left: 0.21333rem;
				color: #ee0a24;
				font-size: 0.37333rem;
				content: '*';
			}
		}

		.title {
			color: #333;
			font-size: 15px;
			font-weight: bold;
		}

		.field {
			padding: 0px;
			font-size: 14px;
			font-weight: lighter;
		}

		.SubmitBtn {
			margin: 0;
			width: 75vw;
		}
	}


</style>



// WEBPACK FOOTER //
// src/pages/invoice/InvoiceTitleDetail.vue